import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { ManageComponentsService } from "../../../../../modules/manage-components/manage-components.service";
import { NotificationsService } from "angular2-notifications";
import { ManageEquipmentService } from "../../../manage-equipment.service";
import { EqualiserBar } from "../../../../../entities/setup/model"

@Component({
  selector: "app-add-equaliser-bar-component",
  templateUrl: "./add-equaliser-bar-component.html",
  styleUrls: ["./add-equaliser-bar-component.scss"],
})
export class AddEqualiserBarComponentComponent implements OnInit {
    selectedToeOut: number;
    selectedConditon: string;
    selectedMakeId: number;
    budgetLife: number = 0;
    cmu: number = 0;
    makeList: any[] = [];
    equipmentBrandId: number;
    addToAllInsp: boolean;
    cost: number;
    equipmentId: number;
    constructor( 
        @Inject(MAT_DIALOG_DATA) public data: any,
        public _dialogRef: MatDialogRef<AddEqualiserBarComponentComponent>,
        private _componentservice: ManageComponentsService,
        private _manageEquipmentService: ManageEquipmentService,
        private _notify: NotificationsService,
    ) {}
    ngOnInit() {
        this.equipmentBrandId = this.data.BrandId;
        this.budgetLife = this.data.BudgetLife;
        this.equipmentId = this.data.EquipmentId;
        this.getBrandList();
    }

    onNoClick() {
        this._dialogRef.close(false);
    }
    getBrandList() {
        this._componentservice.getComponentMakeList().subscribe((result) => {
            this.makeList = result;
            const matchedMake = this.makeList.find((m) => m.Id === this.equipmentBrandId);
            if (matchedMake) {
                this.selectedMakeId = matchedMake.Id;
            } else {
                this.selectedMakeId = null;
            }
        });
    }
    get isSaveEnabled(): boolean {
        return !!(
            this.selectedToeOut &&
            this.selectedConditon &&
            this.selectedMakeId
        );
    }
    onSave(): void {
      const request = new EqualiserBar();
      request.ToeOut = this.selectedToeOut;
      request.Condition = this.selectedConditon;
      request.BrandId = this.selectedMakeId;
      request.BudgetLife = this.budgetLife;
      request.CMU = this.cmu;
      request.Cost = this.cost;
      request.EquipmentId = this.equipmentId;
      request.AddToAllInsp = this.data.AddToAllInsp;
      this._manageEquipmentService.addNewEqualiserBar(request)
        .subscribe({
          next: (res) => {
            if (res.Status === 1) {
              this._notify.success('Success', res.Message);
              this._dialogRef.close(true);
            } else {
              this._notify.error('Error', 'Error while adding Equaliser Bar, Please contact Tracktreads Support');
              console.log('Error', res.Message)
            }
          },
          error: (err) => {
            this._notify.error('Error', err);
          }
        });
    }
}